import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';

import { getIsNextStepAvailable, getIsOpen } from '../../selectors/newAnswer';
import { getAnswerTargetId } from '../../selectors/common';
import { dailyrentCreateReply } from '../../actions/newAnswer/dailyrentCreateAnswer';
import { getIsReviewTab } from '../../selectors/tabs';
import { setError } from '../../actions/newAnswer/answerErrorActions';
import { TThunkDispatch } from '../../types/redux';

const ERROR_TEXT = 'Напишите пару строк в ответ на отзыв';

export const useDailyrentNewReplySubmitHandler = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const openId = useSelector(getIsOpen);
  const targetId = useSelector(getAnswerTargetId(openId));
  const isNextStepAvailable = useSelector(getIsNextStepAvailable);
  const isReview = useSelector(getIsReviewTab);

  return React.useCallback(() => {
    if (isReview && !isNextStepAvailable) {
      dispatch(setError(ERROR_TEXT));

      return;
    }

    dispatch(setError(''));
    dispatch(dailyrentCreateReply(targetId));
  }, [dispatch, isNextStepAvailable, isReview, targetId]);
};
